import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//qard
const KarjoList = Loadable(lazy(() => import("pages/qard-hasan")));
const Details = Loadable(lazy(() => import("pages/qard-hasan/Details")));
const KarjoGiving = Loadable(lazy(() => import("pages/qard-hasan/Giving")));
const KarjoGivingReturn = Loadable(lazy(() => import("pages/qard-hasan/GivingReturn")));
const GivingReturnReceipt = Loadable(lazy(() => import("pages/qard-hasan/GivingReturnReceipt")));

const KarjoTaking = Loadable(lazy(() => import("pages/qard-hasan/Taking")));
const TakingReceipt = Loadable(lazy(() => import("pages/qard-hasan/TakingReceipt")));
const KarjoTakingReturn = Loadable(lazy(() => import("pages/qard-hasan/TakingReturn")));

const QardAlHasanaRoutes = {
  path: "karjo",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <KarjoList />,
    },
    {
      path: "details/:id",
      element: <Details />,
    },
    {
      path: "giving",
      element: <KarjoGiving />,
    },
    {
      path: "return-giving",
      element: <KarjoGivingReturn />,
    },
    {
      path: "return-giving/receipt/:id",
      element: <GivingReturnReceipt />,
    },
    {
      path: "taking",
      element: <KarjoTaking />,
    },
    {
      path: "taking/receipt/:id",
      element: <TakingReceipt />,
    },
    {
      path: "return-taking",
      element: <KarjoTakingReturn />,
    },
  ],
};

export default QardAlHasanaRoutes;
